import { render, staticRenderFns } from "./LayoutOutside.vue?vue&type=template&id=6ab6e5f6&scoped=true&lang=pug"
import script from "./LayoutOutside.vue?vue&type=script&lang=js"
export * from "./LayoutOutside.vue?vue&type=script&lang=js"
import style0 from "./LayoutOutside.vue?vue&type=style&index=0&id=6ab6e5f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab6e5f6",
  null
  
)

export default component.exports